import { render, staticRenderFns } from "./cis.cattle.io.clusterscan.vue?vue&type=template&id=1e06771a&scoped=true&"
import script from "./cis.cattle.io.clusterscan.vue?vue&type=script&lang=js&"
export * from "./cis.cattle.io.clusterscan.vue?vue&type=script&lang=js&"
import style0 from "./cis.cattle.io.clusterscan.vue?vue&type=style&index=0&id=1e06771a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e06771a",
  null
  
)

export default component.exports